export enum UserStatus {
  ACTIVE = "active",
  DEACTIVATED = "deactivated",
  PENDING = "pending",
  ARCHIVED = "archived",
}

// export enum Role {
//   GUEST = "guest",
//   ADMIN = "admin",
//   ROOT = "root",
// }
// export enum UserRoleDisplay {
//   guest = "Guest",
//   admin = "Admin",
//   root = "Root",
// }
export enum Role {
  LEADER = "leader",
  ADMIN = "admin",
}
export enum UserRoleDisplay {
  leader = "Leader",
  admin = "Admin",
}

export enum UserStatusDisplay {
  "new_lead" = "New lead",
  "form_sent" = "Form sent",
  "confirmed" = "Confirmed",
  "invited" = "Invited",
  "active" = "Active",
  "inactive" = "Inactive",
  "archived" = "Archived",
}

export enum UserPlan {
  BASIC = "basic",
  PRO = "pro",
}

export enum UserPlanDisplay {
  basic = "Basic",
  pro = "Pro",
}

export const ROLE_LIST = [Role.ADMIN, Role.LEADER];

export function isRoleEnough(
  currentRole: Role | string | undefined,
  requiredRole: Role | string,
): boolean {
  if (currentRole === requiredRole) {
    return true;
  }

  return (
    ROLE_LIST.indexOf(currentRole as Role) >=
    ROLE_LIST.indexOf(requiredRole as Role)
  );
}
